const META_CHANNELS = ["facebook", "instagram"];

export const isMetaChannel = (channel) => META_CHANNELS.includes(channel);

export const isWhatsAppChannel = (channel) => channel === "whatsapp";

export const getConnectionDisplayStatus = (connection) => {
  if (
    isMetaChannel(connection?.channel) &&
    connection?.status !== "CONNECTED"
  ) {
    return "DISCONNECTED";
  }

  return connection?.status;
};

export const isAwaitingWhatsAppQrCode = (connection) =>
  isWhatsAppChannel(connection?.channel) && connection?.status === "qrcode";

export const shouldReauthorizeMeta = (connection) =>
  isMetaChannel(connection?.channel) &&
  getConnectionDisplayStatus(connection) === "DISCONNECTED";

export const getConnectionManagementActionTypes = (connection) => [
  "edit",
  ...(isMetaChannel(connection?.channel) ? ["reauthorize"] : []),
  "delete",
];

export const getConnectionDisconnectEndpoint = (connection) =>
  isMetaChannel(connection?.channel)
    ? `/meta/connections/${connection.id}`
    : `/whatsappsession/${connection.id}`;
